document.addEventListener("DOMContentLoaded", () => {
    const videoContainer = document.querySelector('.cv-video-full');

    if (!videoContainer) return;

    const desktopVideo = videoContainer.querySelector('.cv-video-desktop');
    const mobileVideo = videoContainer.querySelector('.cv-video-mobile');
    const toggleBtn = videoContainer.querySelector('.cv-video-toggle');


    const playIcon = `
    <svg class="tw-w-14 tw-h-14 tw-text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
      <polygon points="8,5 19,12 8,19" stroke-linejoin="round"/>
    </svg>`;
    const pauseIcon = `
    <svg class="tw-w-14 tw-h-14 tw-text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
      <rect x="6" y="5" width="4" height="14" rx="1"/>
      <rect x="14" y="5" width="4" height="14" rx="1"/>
    </svg>`;
    function getActiveVideo() {
        return window.innerWidth >= 768 ? desktopVideo : mobileVideo;
    }

    function toggleVideo() {
        const video = getActiveVideo();
        if (!video) return;

        if (video.paused) {
            video.play();
            toggleBtn.innerHTML = pauseIcon;
        } else {
            video.pause();
            toggleBtn.innerHTML = playIcon;
        }
    }

    toggleBtn.addEventListener('click', toggleVideo);

    window.addEventListener('resize', () => {
        const video = getActiveVideo();
        toggleBtn.innerHTML = video.paused ? playIcon : pauseIcon;
    });
});